import { Mapper } from "../../../../base/utils/mapper";
import { GeneralResponseModel } from "../../../../domain/models/consult/general-response.model";
import { GeneralResponseEntity } from "../entities/general-response.entity";



export class GeneralImplementationRepositoryMapper extends Mapper<GeneralResponseEntity, GeneralResponseModel> {
    mapFrom(param: GeneralResponseEntity): GeneralResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: GeneralResponseModel): GeneralResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}